import React, { useLayoutEffect, useState } from "react";
import MainTemplate from "@/components/Templates/MainTemplate";
import { EndUserLicenseAgreementPage } from "./AppTemplate";
import useDisableIntercom from "@/hooks/useDisableIntercom";
import { getURLParams } from "@/utils";

function PolicyDesktopTemplate() {
  const [isDesktopWebView, setIsDesktopWebView] = useState(false);

  useDisableIntercom({});
  useLayoutEffect(() => {
    const params = getURLParams();
    const source = params?.get("source") || "";

    if (source?.toLowerCase() !== "app") {
      setIsDesktopWebView(true);
    }
  }, []);

  if (isDesktopWebView) {
    return (
      <MainTemplate>
        <EndUserLicenseAgreementPage showHeader />
      </MainTemplate>
    );
  } else {
    return <EndUserLicenseAgreementPage />;
  }
}

export default PolicyDesktopTemplate;
